import { getBreeds } from "@/shared/http"
import { useQuery } from "@tanstack/react-query"

export const useBreeds = () => {
  return useQuery({
    queryKey: ["pet-breeds"],
    queryFn: async () => {
      const breeds = await getBreeds()
      const options = breeds.map((breed) => ({
        value: breed.key,
        label: breed.label,
        type: breed.type,
      }))

      return options
    },
    staleTime: Infinity,
    cacheTime: Infinity,
  })
}
